export const MATERIAL_TYPE_EBOOKS = "e-bøger";
export const MATERIAL_TYPE_AUDIOBOOKS = "lydbøger";
